import React, { useMemo } from "react"
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap"
import withRouter from "components/Common/withRouter"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"
import TableContainer from "components/Common/TableContainer"
import { DeliveryMan } from "pages/vendor/Delivery-men/DeliveryMen"
import { useTranslation } from "react-i18next"

interface DeliveryMenProps {
  deliveryMen: DeliveryMan[]
  isAllChecked: boolean
  checkedDeliveryMen: DeliveryMan[]
  toggleAllDeliveryMen: () => void
  togglecheckedDeliveryManHandler: (deliveryMan: DeliveryMan) => void
  toggleActiveDeliveryMan: (deliveryMan: DeliveryMan) => void
  deleteDeliveryManHandler: (deliveryMan: DeliveryMan) => void
  editDeliveryManHandler: (deliveryMan: DeliveryMan) => void
  viewDetailsHandler: (deliveryMan: DeliveryMan) => void
  printDeliveredBarcodeHandler: (deliveryMan: DeliveryMan) => void
  location?: any
  initialPage?: number
  onPageChange?: (pageIndex: number) => void
}

const DeliveryMen: React.FC<DeliveryMenProps> = ({
  deliveryMen,
  isAllChecked,
  checkedDeliveryMen,
  toggleAllDeliveryMen,
  togglecheckedDeliveryManHandler,
  toggleActiveDeliveryMan,
  deleteDeliveryManHandler,
  editDeliveryManHandler,
  viewDetailsHandler,
  printDeliveredBarcodeHandler,
  location,
  initialPage = 0,
  onPageChange,
}) => {
  const { t } = useTranslation()

  const columns = useMemo(
    () => [
      {
        Header: () => (
          <input
            type="checkbox"
            className="form-check-input"
            onClick={toggleAllDeliveryMen}
            checked={isAllChecked}
          />
        ),
        accessor: "id",
        Cell: (cellProps: { row: { original: DeliveryMan } }) => {
          return (
            <input
              onClick={() =>
                togglecheckedDeliveryManHandler(cellProps.row.original)
              }
              checked={Boolean(
                checkedDeliveryMen.find(d => d.id === cellProps.row.original.id)
              )}
              type="checkbox"
              className="form-check-input"
            />
          )
        },
      },
      {
        Header: t("deliveryMen_deliveryMenName"),
        accessor: "name",
        filterable: true,
        filter: (rows: any[], id: string, filterValue: string) => {
          if (!filterValue || filterValue.trim() === '') return rows
          const searchTerm = String(filterValue).toLowerCase().trim()

          return rows.filter(row => {
            const {name, id} = row.original as DeliveryMan
            const nameMatch = name.toLowerCase().includes(searchTerm)
            const idMatch = id.toString().toLowerCase().includes(searchTerm)
            return nameMatch || idMatch
          })
        },
        Cell: (cellProps: { row: { original: DeliveryMan } }) => {
          return (
            <div className="d-flex justify-content-start align-items-center gap-3">
              <img
                src="https://placehold.co/30x30/png"
                alt="avatar"
                className="rounded-circle"
                style={{
                  width: "36px",
                  height: "36px",
                }}
              />
              <div className="d-flex flex-column align-items-statrt">
                <p className="mb-0">{cellProps.row.original.name}</p>
                <p className="mb-0">{cellProps.row.original.id}</p>
                <div className="d-flex align-items-center">
                  <i className="bx bxs-star text-warning me-1" />
                  <p className="mb-0">{"__"}</p>
                </div>
              </div>
            </div>
          )
        },
      },
      {
        Header: t("deliveryMen_mobileNumber"),
        accessor: "mobile",
        filterable: true,
        Cell: (cellProps: { row: { original: DeliveryMan } }) => {
          return <>{cellProps.row.original.mobile}</>
        },
      },
      {
        Header: t("deliveryMen_availability"),
        accessor: "availabilityStatus",
        filterable: true,
        Cell: (cellProps: { row: { original: DeliveryMan } }) => {
          return (
            <span className="badge bg-secondary me-1 px-2 py-1 font-size-10">
              {"__"}
            </span>
          )
        },
      },
      {
        Header: t("deliveryMen_address"),
        accessor: "address",
        filterable: true,
        Cell: (cellProps: { row: { original: DeliveryMan } }) => {
          return <>{cellProps.row.original.address || "-"}</>
        },
      },
      {
        Header: t("deliveryMen_activeStatus"),
        accessor: "isActive",
        filterable: true,
        Cell: (cellProps: { row: { original: DeliveryMan } }) => {
          return (
            <div className="form-check form-switch mb-3">
              <input
                type="checkbox"
                className="form-check-input"
                id={`customSwitch${cellProps.row.original.id}`}
                checked={cellProps.row.original.isActive}
                onClick={() => toggleActiveDeliveryMan(cellProps.row.original)}
              />
              <label
                className="form-check-label text-capitalize"
                htmlFor={`customSwitch${cellProps.row.original.id}`}
              >
                {cellProps.row.original.isActive ? "Active" : "Inactive"}
              </label>
            </div>
          )
        },
      },
      {
        Header: " ",
        Cell: (cellProps: { row: { original: DeliveryMan } }) => {
          const deliveryMan = cellProps.row.original
          return (
            <UncontrolledDropdown>
              <DropdownToggle tag="a" className="card-drop">
                <i className="mdi mdi-dots-vertical font-size-18"></i>
              </DropdownToggle>

              <DropdownMenu className="dropdown-menu-end">
                <DropdownItem
                  onClick={() => editDeliveryManHandler(deliveryMan)}
                >
                  <span className="">{t("common_edit")}</span>
                </DropdownItem>
                <DropdownItem
                  onClick={() => printDeliveredBarcodeHandler(deliveryMan)}
                >
                  <span className="">{t("deliveryMen_printDeliveredBarcode")}</span>
                </DropdownItem>
                <DropdownItem onClick={() => viewDetailsHandler(deliveryMan)}>
                  <span className="">{t("common_viewDetails")}</span>
                </DropdownItem>
                <DropdownItem
                  onClick={() => deleteDeliveryManHandler(deliveryMan)}
                >
                  <span className="text-danger">
                    {t("deliveryMen_deleteDelivery")}
                  </span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          )
        },
      },
    ],
    [deliveryMen, t, checkedDeliveryMen]
  )

  return (
    <TableContainer
      columns={columns}
      data={deliveryMen}
      isGlobalFilter={true}
      isAddOptions={false}
      customPageSize={5}
      isJobListGlobalFilter={undefined}
      isAddUserList={undefined}
      handleOrderClicks={undefined}
      handleUserClick={undefined}
      handleCustomerClick={undefined}
      isAddCustList={undefined}
      className={undefined}
      customPageSizeOptions={undefined}
      initialPage={initialPage}
      onPageChange={onPageChange}
    />
  )
}

DeliveryMen.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(DeliveryMen))
